import { Directive, HostBinding, Input } from '@angular/core';

@Directive({
  selector: '[sukaText]'
})
// tslint:disable-next-line: directive-class-suffix
export class TextInput {
  @HostBinding('class.text-input') inputClass = true;
  @HostBinding('class.text-input--invalid') @Input() invalid = false;
  @HostBinding('class.text-input--valid') @Input() valid = false;
  @HostBinding('class.skeleton') @Input() skeleton = false;
}
